import React, { Fragment } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import slide from "../carousel.module.scss";
import g2Logo from "../../../assets/g2_logo.png";

const Slides = data => {
  const starArr = [];
  for (let i = 1; i < 6; i += 1) {
    i <= data.obj.star ? starArr.push(true) : starArr.push(false);
  }

  if (data.obj.star.toString().includes(".5")) {
    for (let i = 0; i < 5; i += 1) {
      if (!starArr[i]) {
        starArr[i] = "half";
        break;
      }
    }
  }
  const starsList = [];
  for (let i = 0; i < starArr.length; i += 1) {
    starsList.push({ id: i, type: starArr[i] });
  }

  return (
    <>
      <h1 className={slide.title}>
        Checkout our user&apos;s <br /> review of Revv
      </h1>
      <div className={slide.flexDisplay}>
        <div className={slide.reviewDetails}>
          <div className={slide.writerDetails}>
            <div className={slide.name}>{data.obj.name}</div>
            <div className={slide.position}>{data.obj.position}</div>
            <div className={slide.company}>{data.obj.company}</div>
          </div>

          <div>
            {starsList.map(e => (
              <Fragment key={e.id}>
                {e.type === "half" && (
                  <FontAwesomeIcon
                    className={slide.stars}
                    icon={["fas", "star-half-alt"]}
                  />
                )}
                {e.type === true && (
                  <FontAwesomeIcon
                    className={slide.stars}
                    icon={["fas", "star"]}
                  />
                )}
                {!e.type && (
                  <FontAwesomeIcon
                    className={slide.stars}
                    icon={["fal", "star"]}
                  />
                )}
              </Fragment>
            ))}
          </div>

          <div className={slide.review}>{data.obj.description}</div>
        </div>

        <div>
          <FontAwesomeIcon
            className={slide.quoteRight}
            icon={["fas", "quote-right"]}
          />
        </div>
      </div>
      <div>
        <img
          className={slide.g2Logo}
          src={g2Logo}
          alt="g2Logo"
          height="62px"
          width="130px"
        />
      </div>
    </>
  );
};
export default Slides;
